<template>
  <v-dialog v-model="showDialog" max-width="600px">
    <template v-slot:activator="{ on }">
      <v-btn v-if="modo != 'insert'" colo="primary" v-on="on" small @click="init()">Editar</v-btn>
      <v-btn v-else colo="primary" v-on="on" @click="init()">Agregar Generacion</v-btn>
    </template>
    <v-card>
      <v-card-title>Modificar generacion </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="validForm">
          <tipo-generacion-autocomplete @tipoGeneracion="setTipoGeneracion" :tipoGeneracion="tipoGeneracion" :rules="[rules.required]" 
            :disabled = "modo != 'insert' && generacion.estado == 'Cerrado'"
          />

          <periodo-distribucion-autocomplete  @periodoDistribucion="setPeriodoDistribucion" :periodoDistribucion="periodoDistribucion" :rules="[rules.required]"  />

          <v-text-field
            type="text"
            label="Descripción"
            :disabled = "modo != 'insert' && generacion.estado == 'Cerrado'"
            v-model="descripcion"
            :rules="[rules.required]"
          />
          
          <v-text-field
            type="text"
            label="Nombre corto"
            :disabled = "modo != 'insert' && generacion.estado == 'Cerrado'"
            v-model="nombreCorto"
            :rules="[rules.required, rules.counter10]"
          />
          <v-checkbox
            v-model="aplicaRetencion"
            label="Aplicar retencion"
            :disabled = "modo != 'insert' && generacion.estado == 'Cerrado'"
          >
          </v-checkbox>

        <v-row class="pa-3 mb-1">

          <MyInputDate
              label="Fecha inicio del periodo" :fecha="fechaInicio"
              @fecha="fecha => this.fechaInicio = fecha"
              :disabled = "modo != 'insert' && generacion.estado == 'Cerrado'"
            />

          <MyInputDate
            label="Fecha fin del periodo" :fecha="fechaFin"
            @fecha="fecha => this.fechaFin = fecha"
            :disabled = "modo != 'insert' && generacion.estado == 'Cerrado'"
          />

        
          </v-row>
        
          <MyInputDate
            label="Fecha de liquidacion" :fecha="fechaLiquidacion"
            @fecha="fecha => this.fechaLiquidacion = fecha"
            :disabled = "modo != 'insert' && generacion.estado == 'Cerrado'"
            required
          />

          

          <servicios-factura-autocomplete @setServicio="setServicioRegalia" returnObject label="Servicio Factura: Regalia" :id="idRegalia" class="mt-2"/>
          <servicios-factura-autocomplete @setServicio="setServicioReconocimiento" returnObject label="Servicio Factura: Reconocimiento" :id="idReconocimiento" />
          <servicios-factura-autocomplete @setServicio="setServicioAyuda" returnObject label="Servicio Factura: Ayuda" :id="idAyuda" />

        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn small color="primary" @click="guardar" :disabled="!validForm">Guardar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import axios from "axios";
import moment from "moment";
import 'moment/locale/es';

import TipoGeneracionAutocomplete from "@/components/shared/TipoGeneracionAutocomplete.vue";
import PeriodoDistribucionAutocomplete from "@/components/shared/PeriodoDistribucionAutocomplete.vue";
import ServiciosFacturaAutocomplete from '../shared/ServiciosFacturaAutocomplete.vue';
import MyInputDate from "../shared/MyInputDate.vue";


export default {
  components: {
    TipoGeneracionAutocomplete,
    PeriodoDistribucionAutocomplete,
    ServiciosFacturaAutocomplete,
    MyInputDate
  },
  props: ["generacion","modo"],
  data() {
    return {
      descripcion: "",
      nombreCorto: "",
      fechaInicio: null,
      fechaFin: null,
      fechaLiquidacion: null,
      tipoGeneracion: null,
      aplicaRetencion: false,
      menu: false,
      showDialog: false,
      idReconocimiento: null,
      idAyuda: null,
      idRegalia: null,
      esFechaValida: false,
      periodoDistribucion: null, 
      rules: {
        required: (value) => !!value || "Requerido.",
        counter: (value) =>
          (value && value.length <= 1000) || "Maximo 100 caracteres",
        counter10: (value) =>
          (value && value.length <= 30) || "Maximo 30 caracteres",
        positive: (value) => value > 0 || "Ingrese un valor mayor a 0",
        isValidDate: (value) => moment(value, ["DD/MM/YYYY"],true).isValid() || "Fecha Invalida, ingrese dia / mes / año"
      },
      validForm: false,
    };
  },
  methods: {
    guardar() {
      let gen = {
        id: this.modo != 'insert' ? this.generacion.id : null,
        descripcion: this.descripcion,
        nombreCorto: this.nombreCorto,
        fechaInicio: this.fechaInicio,
        fechaFin: this.fechaFin,
        fechaLiquidacion: this.fechaLiquidacion,
        tipoGeneracion: this.tipoGeneracion,
        periodoDistribucion: this.periodoDistribucion,
        aplicaRetencion : this.aplicaRetencion,
        idReconocimiento: this.idReconocimiento,
        idAyuda: this.idAyuda,
        idRegalia: this.idRegalia
      };

      
      if (this.modo === 'insert') {
        axios
        .put("/generaciones", gen)
        .then((response) => {
          console.log(response);
          this.$emit("saved", response.data);
          this.$refs.form.reset();
          this.showDialog = false;
        })
        .catch((err) => {
          console.log(err);
        });
      } else {
        axios
          .patch("/generaciones", gen)
          .then((response) => {
            console.log(response);
            this.$emit("saved", response.data);
            // this.$refs.form.reset();
            this.showDialog = false;
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    setTipoGeneracion(e) {
      this.tipoGeneracion = e;
    },
    setPeriodoDistribucion(e) {
      this.periodoDistribucion = e;
    },

    parseDate(date) {
      if (!date) return null;

      if (!moment(date, moment.ISO_8601, true).isValid()) {
        this.date = null;
        return null;
      }

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    formatDate(date) {
      if (!date) return null;

      if (!moment(date, moment.ISO_8601, true).isValid()) {
        this.date = null;
        return null;
      }

      return moment(String(date)).format("DD/MM/YYYY");

    },
    init() {

      if (this.modo != 'insert') {
        this.descripcion = this.generacion.descripcion;
        this.nombreCorto = this.generacion.nombreCorto;
        this.fechaInicio = this.generacion.fechaInicio;
        this.tipoGeneracion = this.generacion.tipoGeneracion;
        this.periodoDistribucion = this.generacion.periodoDistribucion;
        this.fechaFin = this.generacion.fechaFin;
        this.fechaLiquidacion = this.generacion.fechaLiquidacion;
        this.aplicaRetencion = this.generacion.aplicaRetencion;
  
        this.idReconocimiento = this.generacion.idReconocimiento;
        this.idAyuda = this.generacion.idAyuda;
        this.idRegalia = this.generacion.idRegalia;
  

      }

    },
    setServicioRegalia(servicio) {
      this.idRegalia = servicio ? servicio.idServicio : null;
    },
    setServicioReconocimiento(servicio) {
      this.idReconocimiento = servicio ? servicio.idServicio : null;
    },
    setServicioAyuda(servicio) {
      this.idAyuda = servicio ? servicio.idServicio : null;
    },
  },
  watch: {
    date() {
      this.dateFormatted = this.formatDate(this.date);
    },
    menu(val) {
      val && this.$nextTick(() => (this.$refs.picker.activePicker = "YEAR"));
    },
  },
  mounted() {
    
  },
};
</script>
